import { defaultBlock } from './fragments/defaultBlock'
import { form } from './fragments/form'
import { metaFields } from './fragments/metaFields'

const eventQuery = /* groq */ `
{
  "event": *[_type == "event" && slug.current == $slug]  | order(_updatedAt desc) [0] {
    ...,
    ${metaFields},
    eventInformationCopy[]{
      ${defaultBlock}
    },
    copy[]{
      ${defaultBlock}
    },
    eventImage{
      alt,
      colorImage,
      crop{
        ...
      },
      hotspot{
        ...
      },
      asset->{
        ...
      }
    },
    eventVideo{
      ...,
      asset->{
  			...,
	  		"url": "https://stream.mux.com/" + playbackId
			}
    },
    mobileEventVideo{
      ...,
      asset->{
  			...,
	  		"url": "https://stream.mux.com/" + playbackId
			}
    },
    eventMulti{
      showMulti,
      artists[]{
        _key,
        title,exclusive,
        copy[]{
          ...,
          markDefs[]{
            ...,
            internalPage->{
              _type,
              slug{
                  current
              }
            },
            file{
              asset->{
                url
              }
            }
          },
        },
        image{
          alt,
          colorImage,
          crop{
            ...
          },
          hotspot{
            ...
          },
          asset->{
            ...
          }
        },
        eventLink->{
          slug{
            current
          }
        }
      }
    },
    eventLocations[]->{
      ...
    },
    registrationForm->{
      ${form}
    },
    overrides{
      overrideAccessibility,
      overrideAccessibilityCopy[]{
        ${defaultBlock}
      }
    },
    winterFeast {
      stallholders[]{
        ...,
        image{
          ...,
          asset->
        },
        copy[]{
          ${defaultBlock}
        }
      },
      musicColumns[]{
        _key,
        copy[]{
          ${defaultBlock}
        }
      }
    }
  }
}`

const eventSlugsQuery = /* groq */ `
*[_type == "home" && _id == 'home'][0] {
  	"slugs":  events[]->slug.current,
  }
`

const winterfeastEventSlugsQuery = /* groq */ `
*[_type == "event" && slug.current == 'winter-feast'][0] {
	"winterfeastSlugs": winterFeast.stallholders[].slug.current
}
`

export { eventQuery, eventSlugsQuery, winterfeastEventSlugsQuery }
